import { InteractionProperty, InteractionPropertyType } from "./InteractionProperty";

export const openAnswersProperty: InteractionProperty = {
  id: "allowWrongAnswers",
  name: "allowWrongAnswers",
  locId: "allowWrongAnswers",
  type: InteractionPropertyType.boolean,
  value: false,
};

export function hasOpenAnswers(
  interaction: { properties?: InteractionProperty[] } | undefined
): boolean {
  return interaction?.properties?.some(
    (property) => property.id === openAnswersProperty.id && property.value === true
  ) ?? false;
}
